export class Audioplayer {
    players: NodeListOf<Element>;
    audios: HTMLMediaElement[];

    constructor() {
        this.players = document.querySelectorAll('[data-audioplayer]');
        this.audios = [];
        this.init();
    }

    init() {
        this.addEventListeners()
    }

    addEventListeners() {
        this.players.forEach((player) => {
            const audio: HTMLMediaElement = player.querySelector('[data-audioplayer-audio]'),
                duration: HTMLElement = player.querySelector('[data-audioplayer-time="duration"]'),
                playButton: HTMLElement = player.querySelector('[data-audioplayer-play-button]'),
                progress: HTMLElement = player.querySelector('[data-audioplayer-progress="progress"]'),
                current: HTMLElement = player.querySelector('[data-audioplayer-time="current"]'),
                progressBar: HTMLElement = player.querySelector('[data-audioplayer-progress="bar"]'),
                shareButton: HTMLElement = player.querySelector('[data-audioplayer-share="button"]'),
                shareOverlay: HTMLElement = player.querySelector('[data-audioplayer-share="overlay"]');

            this.audios.push(audio);

            audio.load();

            audio.addEventListener('loadeddata', () => {
                duration.innerHTML = this.secondsInMinutesAndSeconds(Math.round(audio.duration));
            });

            audio.addEventListener('play', () => {
                player.classList.add('c-audioplayer--playing');
            });

            audio.addEventListener('pause', () => {
                player.classList.remove('c-audioplayer--playing');
            });

            audio.addEventListener('timeupdate', () => {
                current.innerHTML = this.secondsInMinutesAndSeconds(Math.round(audio.currentTime));
                progress.style.width = 100 * (audio.currentTime / audio.duration) + '%';
            });

            playButton.addEventListener('click', () => {
                if (audio.paused) {
                    this.audios.forEach((item) => {
                        item.pause();
                    });
                    if (audio.ended) {
                        audio.currentTime = 0;
                    }
                    audio.play();
                }
                else {
                    audio.pause();
                }
            });

            progressBar.addEventListener('click', (event) => {
                let clickPercentage = ((event.clientX - progressBar.getBoundingClientRect().left) / progressBar.clientWidth) * 100;
                audio.currentTime = (audio.duration / 100) * clickPercentage;
            });

            if (shareButton && shareOverlay) {
                shareButton.addEventListener('click', () => {
                    shareOverlay.classList.toggle('is-visible');
                });
            }

        });
    }

    secondsInMinutesAndSeconds(time) {
        let pad = function(num, size) {
            return ('000' + num).slice(size * -1);
        };
        let minutes = pad(Math.floor(time / 60), 2);
        let seconds = pad(time - (Math.floor(time / 60) * 60), 2);
        return minutes + ':' + seconds;
    }

}
document.addEventListener("DOMContentLoaded", function() {
    new Audioplayer();
});
